import { useGetOrgSettings } from "@/hooks/useOrg";
import useOrgSettingStore from "@/store/useOrgSettingsStore";
import { useEffect } from "react";
import { useRouter } from 'next/router'
import useAuthStore from "@/store/useAuthStore";

export default function PointsProvider() {
  const router = useRouter()
  const user = useAuthStore.useUser();
  const organizationGroup = user?.bio?.user?.organizationGroup;
  const { data, refetch } = useGetOrgSettings(organizationGroup, { enabled: !!organizationGroup });
  const { setPointTiers } = useOrgSettingStore();

  useEffect(() => {
    if (data) {
      setPointTiers(data[0]?.pointTiers);
    }
  }, [data]);

  useEffect(() => {
    refetch()
  }, [router.pathname])
  return <></>;
}
